import { render, staticRenderFns } from "./AdminAddMember.vue?vue&type=template&id=035c8025&"
import script from "./AdminAddMember.vue?vue&type=script&lang=js&"
export * from "./AdminAddMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports